import { useQuery } from "@tanstack/react-query";
import { listUsers } from "@/services/adminApi";
import { useDebounce } from "./useDebounce";

/**
 * Debounced admin-user search, for typeahead pickers (e.g. UserCombobox).
 * Reusable anywhere a "pick a user" UX is needed — see users/Subscriptions.tsx
 * for the paginated-table equivalent this was factored out of.
 */
export function useUserSearch(search: string, limit = 20) {
  const debouncedSearch = useDebounce(search, 300);
  return useQuery({
    queryKey: ["admin", "users", "search", debouncedSearch, limit],
    queryFn: () => listUsers({ search: debouncedSearch || undefined, limit }),
  });
}
